import React, { useState } from "react";
import {
  Message,
  TextArea,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { codeOk, errorMessage } from "../../lib/index";
import { useClimateContext } from "../../context/ClimateContext";
import { TiWeatherPartlySunny } from "react-icons/ti";

const Add = () => {
  const { createOneClimate } = useClimateContext();

  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [name, setName] = useState(null);
  const [description, setDescription] = useState(null);

  const climateRoutes = "/climate";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setName(null);
    setDescription(null);
  };

  const responses = (isError: any, statusCode: any, msg: any) => {
    setError(isError);
    setStatus(statusCode);
    setErrorMessage(msg);
  };

  const addOneClimateHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = { name, description };
    const response = await createOneClimate(data);

    if (response) {
      if (response.data.status === codeOk) {
        cleanFields();
        return responses(false, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <AddPageShell
      backRoute={climateRoutes}
      eyebrow="Catalog • Climates"
      title="Create Climate"
      subtitle='Define a recognisable climate label such as "Tropical" or "Arid".'
      icon={<TiWeatherPartlySunny className="h-5 w-5" />}
      size="md"
      loading={loading}
      submitLabel="Add Climate"
      onSubmit={addOneClimateHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <Message
          props={{
            error,
            success,
            message,
            loading,
            status,
            onClick: () => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            },
          }}
        />
      }
    >
      <AddSection
        title="Climate Details"
        hint="Briefly describe the typical weather and travel comfort."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            props={{
              id: "title",
              title: "Name",
              type: "text",
              required: true,
              value: name ? name : "",
              onChange: (e: any) => {
                setName(e.target.value);
                setError(false);
                setSuccess(false);
              },
            }}
          />
          <div className="hidden items-center gap-2 rounded-lg bg-gray-50 px-3 py-2 text-[11px] text-gray-600 ring-1 ring-gray-200 md:flex">
            Use a short, recognisable label (e.g. "Tropical", "Arid").
          </div>
          <div className="md:col-span-2">
            <TextArea
              props={{
                id: "description",
                title: "Description",
                type: "text",
                required: true,
                value: description ? description : "",
                onChange: (e: any) => {
                  setDescription(e.target.value);
                  setError(false);
                  setSuccess(false);
                },
              }}
            />
          </div>
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Add;
